module.exports = __webpack_public_path__ + "static/youtube_social_icon_dark-b54f7a639b5a7206d903933014987236.png";